import { IAidasObject } from 'app/shared/model/ainnotateservice/aidas-object.model';
import { IAidasProperties } from 'app/shared/model/ainnotateservice/aidas-properties.model';

export interface IAidasObjectProperty {
  id?: number;
  value?: string | null;
  aidasObject?: IAidasObject;
  aidasProperties?: IAidasProperties;
}

export const defaultValue: Readonly<IAidasObjectProperty> = {};
